export default function isServerSideRendering() {
    return typeof document === 'undefined' || typeof window === 'undefined';
}

//# sourceMappingURL=isSSR.js.map